// import visible from "@/common/assets/icons/visible.svg";
// import invisible from "@/common/assets/icons/hidden.svg";
import {
	EventBusCase,
	EventBusNavbar,
	EventButton,
	EventCurdSideMenu,
	EventSideMenu
} from "@/common/configurations/event-bus";
import {API_HEADER, NOTIFICATION_TYPE} from "@/common/utils/constants";
import * as LOGIN_SERVICE from "@/common/services/login-service";

const loginMixin = {
	data() {
		return {
			visible: require('@/common/assets/icons/visible.svg'),
			hidden: require('@/common/assets/icons/hidden.svg'),
			error: ''
		}
	},
	methods: {
		setJwt(response, isSso, directory) {
			let user = response.data;
			user.isSso = isSso;

			if (!user.jwt) {
				throw new Error(`JWT is missing from HTTP header "${API_HEADER.authorization}"`);
			}

			if (user.jwt) {
				this.$store.dispatch('signIn', response);
				this.attachUserIdToHotjar(user);
				LOGIN_SERVICE.getNotificationsForProjectsWaitingForApproval();
				LOGIN_SERVICE.getNotificationsForPublishedProjects();
				LOGIN_SERVICE.redirectAfterLogin();
				this.registerGoogleAnalyticsLoginEvent(isSso, directory);
				this.checkForChatNow();
			}
		},
		checkForChatNow(){
			const allowedEmails = ['vasil.ayvazov@akkodis.com', 'petar.stoyanov@akkodis.com', 'sabiha.mangova@akkodis.com', 'desislava.aleksandrova@akkodis.com',
				'plamen.velichkov@akkodis.com', 'pavlina.venkova@akkodis.com', 'thibaut.vachet@akkodis.com', 'thibaut.vachet@akkodisgroup.com', 'sebastien.jullien@akkodis.com',
				'martin.nikolov@akkodis.com', 'nicolas@heymadeleine.com', 'jeffrey.sachs@akkodisgroup.com', 'victor.de-longevialle@akkodis.com', 'antoine-amaury.guillerm@akkodis.com',
				'estelle.higgins@akkodis.com', 'debasis.bisoi@akkodis.com', 'segolene.chambrier@akkodis.com', 'sebastien.lauvergne@akkodis.com', 'bertrand.girardeau@akkodis.com',
				'jacques.deperetti@akkodis.com', 'christian.krapichler@akkodis.com', 'olivier.mathelot-orban@akkodis.com', 'joshua.morley@akkodisgroup.com', 'james.bromberger@akkodis.com',
				'ivan.katsarski@akkodis.com', 'filipe.barbosa@akkodis.com', 'gmi@akkodis.dk', 'maria.bergving@akkodisgroup.com', 'temitope.ayorinde@akkodis.com', 'annabelle.ducellier@akkodis.com',
				'sei@akkodis.no', 'wayne.trimble@akkodisgroup.com', 'kimela.tipton@akkodisgroup.com', 'stephane.averty@akkodis.com', 'franck.maurin@akkodis.com', 'sarah.goeller@akkodis.com',
				'sebastien.ramirez@akkodis.com', 'sarah.otley@akkodisgroup.com', 'carol.gobby@akkodis.com', 'matthew.chapman@akkodis.com', 'jo.debecker@akkodis.com', ' sebastien.sauvage@akkodis.com',
				'vladimir.valev@akkodis.com', 'karla.el-harfouch@akkodis.com', 'geraldine.laloux@akkodis.com', 'arnaud.durel@akkodis.com'
			];
			if(allowedEmails.indexOf(this.$store.getters.getUser.email.toLowerCase()) === -1){
				if(document.getElementById('aicore-chatnow-embed-chat-container')){
					document.getElementById('aicore-chatnow-embed-chat-container').remove();
				}
				if(document.getElementById('aicore-chatnow-embed-chat-button-container')){
					document.getElementById('aicore-chatnow-embed-chat-button-container').remove();
				}
			}else{
				if(document.getElementById('aicore-chatnow-embed-chat-container')){
					document.getElementById('aicore-chatnow-embed-chat-container').style.visibility = "visible";
					document.getElementById('aicore-chatnow-embed-chat-container').parentNode.classList.add('showChild')
				}
			}
		},
		attachUserIdToHotjar(user) {
			window.hj = window.hj || function(){(window.hj.q = window.hj.q || []).push(arguments)};
			if (window.hj && user.id) {
				window.hj('identify', user.id, {
					id: user.id,
				});
			} else {
				console.error("User id was not attached to Hotjar")
			}
		},
		registerGoogleAnalyticsLoginEvent(isSso, directory) {
			const now = new Date();
			this.$gtag.event(isSso ? "user_login_sso" : "user_login_guest", {
				event_type: "login",
				event_category: "login",
				event_page: isSso ? "SSO" :"guest",
				event_label: isSso ? "user logged in with SSO" : "user logged in as guest",
				year: now.getFullYear(),
				month: now.getMonth() + 1,
				day: now.getDate(),
				time: new Date().toJSON().split('T')[1].split('.')[0],
				type: isSso ? directory : "Guest"
			});
		},
		redirectTo(path, eventAction) {
			if (eventAction) {
				EventButton.$emit(eventAction)
			}
			this.$router.push(path)
		},
		togglePasswordVisibility(id) {
			const passwordInput = document.getElementById(id);
			const img = passwordInput.parentNode.querySelector('.toggle-password > img');
			if (passwordInput.type === "password") {
				passwordInput.type = "text";
				img.src = this.hidden;
			} else {
				passwordInput.type = "password";
				img.src = this.visible;
			}
		},
	}
}

export default loginMixin;
